import {ProductItem} from '../ProductItem';
import {Splide, SplideSlide} from '@splidejs/react-splide';
import {ProductSummary} from '~/features/shared';

export interface ProductsSliderMobileProps {
  items: ProductSummary[];
}

export function ProductsSliderMobile({items}: ProductsSliderMobileProps) {
  return (
    <Splide
      className="md:hidden"
      options={{
        type: 'loop',
        drag: 'free',
        perPage: 1,
        autoplay: true,
        snap: true,
        pagination: false,
      }}
    >
      {items.map((item) => {
        return (
          <SplideSlide key={item.handle}>
            <ProductItem
              product={item}
              className="px-5 sm:px-10"
              imageClassName="h-[24rem]"
            />
          </SplideSlide>
        );
      })}
    </Splide>
  );
}
